import type {
  AdminOverlayDefinition,
  AdminViewDefinition,
} from "../../components/admin-components.js";
import { card, drawer, withDrawer } from "../_shared/overlay-definition-helpers.js";

export const auditOverlayViews: AdminViewDefinition[] = [
  withDrawer("audit-detail", "audit-explorer", auditDetailDrawer()),
];

function auditDetailDrawer(): AdminOverlayDefinition {
  return drawer("Audit event detail", "Immutable event context with protected fields masked.", [
    alphabetizedCard("Fields", [
      "Actor - Avery Reed",
      "Role - SYSTEM_ADMIN",
      "Action - SUPPORT_SESSION_STARTED",
      "Result - Success",
      "Correlation ID - corr_8f1c2",
      "Store - TechGear Store",
      "Entity - Support session",
      "Reason - Investigate repeated extraction failures",
    ]),
  ]);
}

function alphabetizedCard(title: string, values: string[]): ReturnType<typeof card> {
  return card(
    title,
    [...values].sort((left, right) => fieldLabel(left).localeCompare(fieldLabel(right))),
  );
}

function fieldLabel(value: string): string {
  return value.split(" - ")[0] ?? "";
}
